import { render, staticRenderFns } from "./Competition.view.vue?vue&type=template&id=32eec7ce&scoped=true&"
import script from "./Competition.view.vue?vue&type=script&lang=js&"
export * from "./Competition.view.vue?vue&type=script&lang=js&"
import style0 from "./Competition.view.vue?vue&type=style&index=0&id=32eec7ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eec7ce",
  null
  
)

export default component.exports